module.exports = __webpack_public_path__ + "img/MGH-Toyosu-8.0afab93f.jpg";